import Lottie from 'react-lottie';
import PropTypes from 'prop-types';

/**
 * LottieAnimation
 *  - A component extended from react-lottie package and tailored to
 *  - serve animations for scrollable component.
 */
export class LottieAnimation extends Lottie {
  componentWillMount() {
    this.setDocumentHeight();
  }

  componentDidUpdate(prevProps) {
    if (this.props.value !== prevProps.value) {
      this.setDocumentHeight();
    }

    if (this.props.scrollTip !== prevProps.scrollTip && this.anim.totalFrames) {
      this.anim.goToAndStop(this.getNextFrame(), true);
    }
  }

  getNewDocumentHeight = () => {
    const powerValue = 10 - this.props.value;
    return this.props.options.animationData.op * Math.pow(2, powerValue);
  };

  setDocumentHeight() {
    document.body.style.height = `${this.getNewDocumentHeight()}px`;
  }

  getNextFrame() {
    const percentageValue = this.props.scrollTip / 100;
    const calculatedFrame = this.anim.totalFrames * percentageValue;
    return Math.round(calculatedFrame);
  }
}

LottieAnimation.propTypes = {
  /**
   * The step value that determines how fast or slow the scoll
   * works
   */
  value: PropTypes.number,
  /**
   * The current value or scrollTip
   */
  scrollTip: PropTypes.number,
  /**
   * The animation playback options
   */
  options: PropTypes.shape({
    loop: PropTypes.bool,
    autoplay: PropTypes.bool,
    animationData: PropTypes.object,
    rendererSettings: PropTypes.shape({
      preserveAspectRatio: PropTypes.string,
    }),
  }).isRequired,
  /**
   * Offset value for the drag Option
   */
  dragOffset: PropTypes.number,
  /**
   * This is an array of objects containing a eventName and callback function
   * that will be registered as eventlisteners on the animation object.
   */
  eventListeners: PropTypes.arrayOf(
    PropTypes.shape({
      eventName: PropTypes.string,
      callback: PropTypes.func,
    })
  ),
  /**
   * Boolean value to determine if clickToPause options avaliable
   */
  isClickToPauseDisabled: PropTypes.bool,
  /**
   * Boolean value specifying if the animation is paused
   */
  isPaused: PropTypes.bool,
  /**
   * Inline style object
   */
  style: PropTypes.object,
};

LottieAnimation.defaultProps = {
  ...Lottie.defaultProps,
  dragOffset: 0,
  value: 4.5,
  style: {pointerEvents: 'none'},
  isPaused: true,
  isClickToPauseDisabled: true,
};
